import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { ArrowRight } from 'lucide-react';
import { DemoDialog } from '../DemoDialog';
function DashboardMockup() {
  return <div className="relative max-w-4xl mx-auto" data-id="element-391">
      {/* Subtle glow */}
      <div className="absolute -inset-8 bg-cyan-500/[0.04] rounded-3xl blur-2xl" data-id="element-392" />

      <div className="relative bg-white/[0.04] border border-white/[0.08] rounded-2xl p-5 md:p-6" data-id="element-393">
        {/* Top bar */}
        <div className="flex items-center gap-3 mb-5 pb-4 border-b border-white/[0.06]" data-id="element-394">
          <div className="flex gap-1.5" data-id="element-395">
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.12]" data-id="element-396" />
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.12]" data-id="element-397" />
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.12]" data-id="element-398" />
          </div>
          <div className="flex-1 h-5 bg-white/[0.04] rounded-md max-w-xs mx-auto" data-id="element-399" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-400">
          {/* Left: Calendar wireframe */}
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4" data-id="element-401">
            <div className="flex items-center justify-between mb-4" data-id="element-402">
              <div className="h-3 w-16 bg-white/[0.10] rounded" data-id="element-403" />
              <div className="flex gap-1" data-id="element-404">
                <div className="h-5 w-5 bg-white/[0.06] rounded" data-id="element-405" />
                <div className="h-5 w-5 bg-white/[0.06] rounded" data-id="element-406" />
              </div>
            </div>
            {/* Day headers */}
            <div className="grid grid-cols-7 gap-1 mb-2" data-id="element-407">
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-408" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-409" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-410" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-411" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-412" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-413" />
              <div className="h-2 bg-white/[0.06] rounded" data-id="element-414" />
            </div>
            {/* Calendar grid */}
            <div className="grid grid-cols-7 gap-1" data-id="element-415">
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-416" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-417" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-418" />
              <div className="aspect-square bg-cyan-500/20 rounded-sm" data-id="element-419" />
              <div className="aspect-square bg-cyan-500/30 rounded-sm" data-id="element-420" />
              <div className="aspect-square bg-cyan-500/20 rounded-sm" data-id="element-421" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-422" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-423" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-424" />
              <div className="aspect-square bg-cyan-500/15 rounded-sm" data-id="element-425" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-426" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-427" />
              <div className="aspect-square bg-cyan-500/25 rounded-sm" data-id="element-428" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-429" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-430" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-431" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-432" />
              <div className="aspect-square bg-cyan-500/20 rounded-sm" data-id="element-433" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-434" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-435" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-436" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-437" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-438" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-439" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-440" />
              <div className="aspect-square bg-cyan-500/15 rounded-sm" data-id="element-441" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-442" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-443" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-444" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-445" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-446" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-447" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-448" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-449" />
              <div className="aspect-square bg-white/[0.04] rounded-sm" data-id="element-450" />
            </div>
          </div>

          {/* Center: Attendee directory */}
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4" data-id="element-451">
            <div className="h-3 w-24 bg-white/[0.10] rounded mb-4" data-id="element-452" />
            <div className="space-y-3" data-id="element-453">
              {/* Attendee card 1 */}
              <div className="bg-white/[0.05] border border-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-454">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex-shrink-0" data-id="element-455" />
                <div className="flex-1 space-y-1.5" data-id="element-456">
                  <div className="h-2.5 w-20 bg-white/[0.12] rounded" data-id="element-457" />
                  <div className="h-2 w-28 bg-white/[0.06] rounded" data-id="element-458" />
                </div>
              </div>
              {/* Attendee card 2 */}
              <div className="bg-white/[0.05] border border-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-459">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex-shrink-0" data-id="element-460" />
                <div className="flex-1 space-y-1.5" data-id="element-461">
                  <div className="h-2.5 w-16 bg-white/[0.12] rounded" data-id="element-462" />
                  <div className="h-2 w-24 bg-white/[0.06] rounded" data-id="element-463" />
                </div>
              </div>
              {/* Attendee card 3 */}
              <div className="bg-white/[0.05] border border-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-464">
                <div className="w-8 h-8 rounded-full bg-indigo-500/20 flex-shrink-0" data-id="element-465" />
                <div className="flex-1 space-y-1.5" data-id="element-466">
                  <div className="h-2.5 w-24 bg-white/[0.12] rounded" data-id="element-467" />
                  <div className="h-2 w-20 bg-white/[0.06] rounded" data-id="element-468" />
                </div>
              </div>
              {/* Attendee card 4 */}
              <div className="bg-white/[0.05] border border-white/[0.06] rounded-lg p-3 flex items-center gap-3" data-id="element-469">
                <div className="w-8 h-8 rounded-full bg-emerald-500/20 flex-shrink-0" data-id="element-470" />
                <div className="flex-1 space-y-1.5" data-id="element-471">
                  <div className="h-2.5 w-18 bg-white/[0.12] rounded" data-id="element-472" />
                  <div className="h-2 w-26 bg-white/[0.06] rounded" data-id="element-473" />
                </div>
              </div>
            </div>
          </div>

          {/* Right: Meeting scheduler modal */}
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4" data-id="element-474">
            <div className="h-3 w-28 bg-white/[0.10] rounded mb-2" data-id="element-475" />
            <div className="h-2 w-20 bg-white/[0.06] rounded mb-5" data-id="element-476" />
            {/* Time slots */}
            <div className="space-y-2.5 mb-5" data-id="element-477">
              <div className="bg-cyan-500/10 border border-cyan-500/20 rounded-lg p-3 flex items-center justify-between" data-id="element-478">
                <div className="space-y-1" data-id="element-479">
                  <div className="h-2.5 w-14 bg-cyan-400/30 rounded" data-id="element-480" />
                  <div className="h-2 w-24 bg-white/[0.06] rounded" data-id="element-481" />
                </div>
                <div className="w-5 h-5 rounded-full border-2 border-cyan-500/40 flex items-center justify-center" data-id="element-482">
                  <div className="w-2.5 h-2.5 rounded-full bg-cyan-500/60" data-id="element-483" />
                </div>
              </div>
              <div className="bg-white/[0.04] border border-white/[0.06] rounded-lg p-3 flex items-center justify-between" data-id="element-484">
                <div className="space-y-1" data-id="element-485">
                  <div className="h-2.5 w-14 bg-white/[0.10] rounded" data-id="element-486" />
                  <div className="h-2 w-20 bg-white/[0.06] rounded" data-id="element-487" />
                </div>
                <div className="w-5 h-5 rounded-full border-2 border-white/[0.12]" data-id="element-488" />
              </div>
              <div className="bg-white/[0.04] border border-white/[0.06] rounded-lg p-3 flex items-center justify-between" data-id="element-489">
                <div className="space-y-1" data-id="element-490">
                  <div className="h-2.5 w-14 bg-white/[0.10] rounded" data-id="element-491" />
                  <div className="h-2 w-22 bg-white/[0.06] rounded" data-id="element-492" />
                </div>
                <div className="w-5 h-5 rounded-full border-2 border-white/[0.12]" data-id="element-493" />
              </div>
            </div>
            {/* Confirm button wireframe */}
            <div className="h-9 bg-cyan-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center" data-id="element-494">
              <div className="h-2.5 w-16 bg-cyan-400/40 rounded" data-id="element-495" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function HeroSection() {
  return <section className="w-full relative overflow-hidden font-heading" style={{
    backgroundColor: '#09090B'
  }} data-id="element-496">
      {/* Dot grid background */}
      <div className="absolute inset-0 opacity-40" style={{
      backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.03) 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-497" />

      {/* Subtle gradient orbs */}
      <div className="absolute top-0 left-1/3 w-[600px] h-[600px] bg-cyan-500/[0.04] rounded-full blur-[150px]" data-id="element-498" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-blue-600/[0.03] rounded-full blur-[120px]" data-id="element-499" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center" data-id="element-500">
        {/* Eyebrow */}
        <Badge className="mb-8 bg-cyan-500/10 text-cyan-400 border-cyan-500/20 px-4 py-1.5 text-xs font-mono uppercase tracking-wider rounded-full" data-id="element-501">
          Infrastructure Technologique événementielle 🇲🇦
        </Badge>

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] text-white tracking-tight" data-id="element-502">
          Une plateforme.
          <br data-id="element-503" />
          Chaque moment de votre événement.
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-white/50 max-w-3xl mx-auto leading-relaxed mt-6" data-id="element-504">
          MeetOS gère l'inscription, l'agenda, le networking, le check-in sur
          site, la gestion des exposants, l'engagement en direct et l'analytique
          post-événement — dans une plateforme white-label unique accessible
          depuis n'importe quel appareil, sans téléchargement.
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-wrap justify-center gap-4" data-id="element-505">
          <DemoDialog data-id="element-506">
            <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0 px-8 shadow-[0_0_20px_rgba(6,182,212,0.3)]" data-id="element-507">
              Demander une démo
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-508" />
            </Button>
          </DemoDialog>
          <Link to="/plateforme" data-id="element-509">
            <Button variant="default" size="lg" className="bg-cyan-500/10 border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/20 hover:text-cyan-300 px-8" data-id="element-510">
              Explorer la plateforme
            </Button>
          </Link>
        </div>

        {/* Trust line */}
        <p className="mt-6 text-sm text-white/30 font-mono" data-id="element-511">
          White-label · Multi-langue · Déployé en Afrique, Europe et
          Moyen-Orient.
        </p>

        {/* Dashboard mockup */}
        <div className="mt-16" data-id="element-512">
          <DashboardMockup data-id="element-513" />
        </div>
      </div>
    </section>;
}